const reasons = [
  {
    icon: "ri-lock-line",
    title: "秘密厳守・近隣配慮",
    text: "無地の作業車両・目隠し養生で、近隣に知られず作業。プライバシーに最大限配慮します。",
  },
  {
    icon: "ri-user-star-line",
    title: "経験豊富な専門スタッフ",
    text: "ゴミ屋敷清掃の実績豊富なスタッフが、どんな状況のお部屋もスピーディーに片付けます。",
  },
  {
    icon: "ri-shield-check-line",
    title: "消臭・除菌・害虫駆除まで対応",
    text: "ゴミの搬出だけでなく、消臭・除菌・害虫駆除までトータルで対応。清潔な空間に仕上げます。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "明朗会計・追加料金なし",
    text: "お見積り後の追加料金は一切いただきません。事前の写真見積りで安心の料金提示を行います。",
  },
];

export default function Reasons() {
  return (
    <section id="reasons" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            REASONS
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都のゴミ屋敷清掃が
            <br className="sm:hidden" />
            <span className="text-primary-500">選ばれる理由</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 mb-5">
                <i className={`${r.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                {r.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}